import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { ConfirmProvider } from 'material-ui-confirm'

import { AccountProvider } from 'hooks/useAccount'
import { AuthProvider } from 'lib/auth'

import App from './App'
import * as serviceWorker from './serviceWorker'
import ThemeProvider from './ThemeProvider'

import './index.css'

createRoot(document.getElementById('root')).render(
  <ThemeProvider>
    <AuthProvider>
      <AccountProvider>
        <BrowserRouter>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </BrowserRouter>
      </AccountProvider>
    </AuthProvider>
  </ThemeProvider>
)

serviceWorker.unregister()
